import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../src/layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_54604f30 from 'nuxt_plugin_plugin_54604f30' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_4de1dc0a from 'nuxt_plugin_sentryserver_4de1dc0a' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_2faf2afc from 'nuxt_plugin_sentryclient_2faf2afc' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_0c8eb7d0 from 'nuxt_plugin_plugin_0c8eb7d0' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_gtm_dbd73ac8 from 'nuxt_plugin_gtm_dbd73ac8' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_nuxtuseragent_1254e4e2 from 'nuxt_plugin_nuxtuseragent_1254e4e2' // Source: ./nuxt-user-agent.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_674415ee from 'nuxt_plugin_cookieuniversalnuxt_674415ee' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_buefy_fd0a7cd2 from 'nuxt_plugin_buefy_fd0a7cd2' // Source: ./buefy.js (mode: 'all')
import nuxt_plugin_vuescrollto_40fb4903 from 'nuxt_plugin_vuescrollto_40fb4903' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_dayjsplugin_a5d5c852 from 'nuxt_plugin_dayjsplugin_a5d5c852' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_pluginutils_ea6a7e96 from 'nuxt_plugin_pluginutils_ea6a7e96' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_8dc41680 from 'nuxt_plugin_pluginrouting_8dc41680' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7e05a2a2 from 'nuxt_plugin_pluginmain_7e05a2a2' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_nuxtmq_c54d6c64 from 'nuxt_plugin_nuxtmq_c54d6c64' // Source: ./nuxt-mq.js (mode: 'all')
import nuxt_plugin_googleanalytics_0f318e20 from 'nuxt_plugin_googleanalytics_0f318e20' // Source: ./google-analytics.js (mode: 'client')
import nuxt_plugin_lazySizes_730f61be from 'nuxt_plugin_lazySizes_730f61be' // Source: ./lazySizes.js (mode: 'all')
import nuxt_plugin_fontawesome_3b6c4908 from 'nuxt_plugin_fontawesome_3b6c4908' // Source: ./fontawesome.js (mode: 'all')
import nuxt_plugin_provideenviromenthosts_0cf1a1e9 from 'nuxt_plugin_provideenviromenthosts_0cf1a1e9' // Source: ../src/plugins/global-setup/provide_enviroment_hosts (mode: 'all')
import nuxt_plugin_jsonserializeenhancer_55b14c62 from 'nuxt_plugin_jsonserializeenhancer_55b14c62' // Source: ../src/plugins/json-serialize-enhancer (mode: 'all')
import nuxt_plugin_globalstore_65cff22b from 'nuxt_plugin_globalstore_65cff22b' // Source: ../src/plugins/global-store (mode: 'all')
import nuxt_plugin_veevalidate_346f6561 from 'nuxt_plugin_veevalidate_346f6561' // Source: ../src/plugins/vee-validate (mode: 'all')
import nuxt_plugin_vueawesomeswiper_0f4ed586 from 'nuxt_plugin_vueawesomeswiper_0f4ed586' // Source: ../src/plugins/vue-awesome-swiper (mode: 'all')
import nuxt_plugin_visible_53dde73e from 'nuxt_plugin_visible_53dde73e' // Source: ../src/plugins/directive/visible (mode: 'all')
import nuxt_plugin_testid_622b74e1 from 'nuxt_plugin_testid_622b74e1' // Source: ../src/plugins/directive/testid (mode: 'all')
import nuxt_plugin_dev_425e7e3e from 'nuxt_plugin_dev_425e7e3e' // Source: ../src/plugins/directive/dev (mode: 'all')
import nuxt_plugin_vuestickydirective_48a9bb86 from 'nuxt_plugin_vuestickydirective_48a9bb86' // Source: ../src/plugins/directive/vue-sticky-directive (mode: 'all')
import nuxt_plugin_vueintersectdirective_8701e5b4 from 'nuxt_plugin_vueintersectdirective_8701e5b4' // Source: ../src/plugins/directive/vue-intersect-directive (mode: 'all')
import nuxt_plugin_cookieuniversal_5a06e7d4 from 'nuxt_plugin_cookieuniversal_5a06e7d4' // Source: ../src/plugins/cookie-universal (mode: 'all')
import nuxt_plugin_globalerrorhandler_79da93cf from 'nuxt_plugin_globalerrorhandler_79da93cf' // Source: ../src/plugins/global-error-handler (mode: 'all')
import nuxt_plugin_nuxtuseragent_a40f51ce from 'nuxt_plugin_nuxtuseragent_a40f51ce' // Source: ../src/plugins/nuxt-user-agent (mode: 'all')
import nuxt_plugin_frompathchecker_37f83848 from 'nuxt_plugin_frompathchecker_37f83848' // Source: ../src/plugins/from-path-checker (mode: 'all')
import nuxt_plugin_vueinfiniteloading_7913c7de from 'nuxt_plugin_vueinfiniteloading_7913c7de' // Source: ../src/plugins/vue-infinite-loading (mode: 'all')
import nuxt_plugin_provideapolloclient_65d48fd5 from 'nuxt_plugin_provideapolloclient_65d48fd5' // Source: ../src/plugins/global-setup/provide_apollo_client (mode: 'all')
import nuxt_plugin_providesubscriptionunread_60e507aa from 'nuxt_plugin_providesubscriptionunread_60e507aa' // Source: ../src/plugins/global-setup/provide_subscription_unread (mode: 'all')
import nuxt_plugin_meta_b5aab5ac from 'nuxt_plugin_meta_b5aab5ac' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"meta":[{"charset":"utf-8"},{"hid":"viewport","name":"viewport","content":"width=device-width, height=device-height, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0"},{"hid":"aapplication-name","name":"application-name","content":"Careermap"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"Careermap"},{"hid":"msapplication-config","name":"msapplication-config","content":"\u002Ffavicons\u002Fbrowserconfig.xml"}],"link":[{"hid":"icon","rel":"icon","href":"\u002Ffavicons\u002Ffavicon.ico"},{"hid":"icon16","rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicons\u002Ffavicon-16x16.png"},{"hid":"icon32","rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicons\u002Ffavicon-32x32.png"},{"hid":"apple-touch-icon","rel":"apple-touch-icon","sizes":"180x180","href":"\u002Ffavicons\u002Fapple-touch-icon.png"},{"hid":"manifest","rel":"manifest","href":"\u002Ffavicons\u002Fsite.webmanifest"},{"hid":"mask-icon","rel":"mask-icon","color":"#2aa315","href":"\u002Ffavicons\u002Fsafari-pinned-tab.svg"},{"type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@5.8.55\u002Fcss\u002Fmaterialdesignicons.min.css","rel":"preload","as":"style","onload":"this.rel='stylesheet'"}],"style":[],"script":[{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-5WCDHXX')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-5WCDHXX&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_54604f30 === 'function') {
    await nuxt_plugin_plugin_54604f30(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_4de1dc0a === 'function') {
    await nuxt_plugin_sentryserver_4de1dc0a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_2faf2afc === 'function') {
    await nuxt_plugin_sentryclient_2faf2afc(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_0c8eb7d0 === 'function') {
    await nuxt_plugin_plugin_0c8eb7d0(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_dbd73ac8 === 'function') {
    await nuxt_plugin_gtm_dbd73ac8(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtuseragent_1254e4e2 === 'function') {
    await nuxt_plugin_nuxtuseragent_1254e4e2(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_674415ee === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_674415ee(app.context, inject)
  }

  if (typeof nuxt_plugin_buefy_fd0a7cd2 === 'function') {
    await nuxt_plugin_buefy_fd0a7cd2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_40fb4903 === 'function') {
    await nuxt_plugin_vuescrollto_40fb4903(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_a5d5c852 === 'function') {
    await nuxt_plugin_dayjsplugin_a5d5c852(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_ea6a7e96 === 'function') {
    await nuxt_plugin_pluginutils_ea6a7e96(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_8dc41680 === 'function') {
    await nuxt_plugin_pluginrouting_8dc41680(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_7e05a2a2 === 'function') {
    await nuxt_plugin_pluginmain_7e05a2a2(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtmq_c54d6c64 === 'function') {
    await nuxt_plugin_nuxtmq_c54d6c64(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_0f318e20 === 'function') {
    await nuxt_plugin_googleanalytics_0f318e20(app.context, inject)
  }

  if (typeof nuxt_plugin_lazySizes_730f61be === 'function') {
    await nuxt_plugin_lazySizes_730f61be(app.context, inject)
  }

  if (typeof nuxt_plugin_fontawesome_3b6c4908 === 'function') {
    await nuxt_plugin_fontawesome_3b6c4908(app.context, inject)
  }

  if (typeof nuxt_plugin_provideenviromenthosts_0cf1a1e9 === 'function') {
    await nuxt_plugin_provideenviromenthosts_0cf1a1e9(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonserializeenhancer_55b14c62 === 'function') {
    await nuxt_plugin_jsonserializeenhancer_55b14c62(app.context, inject)
  }

  if (typeof nuxt_plugin_globalstore_65cff22b === 'function') {
    await nuxt_plugin_globalstore_65cff22b(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_346f6561 === 'function') {
    await nuxt_plugin_veevalidate_346f6561(app.context, inject)
  }

  if (typeof nuxt_plugin_vueawesomeswiper_0f4ed586 === 'function') {
    await nuxt_plugin_vueawesomeswiper_0f4ed586(app.context, inject)
  }

  if (typeof nuxt_plugin_visible_53dde73e === 'function') {
    await nuxt_plugin_visible_53dde73e(app.context, inject)
  }

  if (typeof nuxt_plugin_testid_622b74e1 === 'function') {
    await nuxt_plugin_testid_622b74e1(app.context, inject)
  }

  if (typeof nuxt_plugin_dev_425e7e3e === 'function') {
    await nuxt_plugin_dev_425e7e3e(app.context, inject)
  }

  if (typeof nuxt_plugin_vuestickydirective_48a9bb86 === 'function') {
    await nuxt_plugin_vuestickydirective_48a9bb86(app.context, inject)
  }

  if (typeof nuxt_plugin_vueintersectdirective_8701e5b4 === 'function') {
    await nuxt_plugin_vueintersectdirective_8701e5b4(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversal_5a06e7d4 === 'function') {
    await nuxt_plugin_cookieuniversal_5a06e7d4(app.context, inject)
  }

  if (typeof nuxt_plugin_globalerrorhandler_79da93cf === 'function') {
    await nuxt_plugin_globalerrorhandler_79da93cf(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtuseragent_a40f51ce === 'function') {
    await nuxt_plugin_nuxtuseragent_a40f51ce(app.context, inject)
  }

  if (typeof nuxt_plugin_frompathchecker_37f83848 === 'function') {
    await nuxt_plugin_frompathchecker_37f83848(app.context, inject)
  }

  if (typeof nuxt_plugin_vueinfiniteloading_7913c7de === 'function') {
    await nuxt_plugin_vueinfiniteloading_7913c7de(app.context, inject)
  }

  if (typeof nuxt_plugin_provideapolloclient_65d48fd5 === 'function') {
    await nuxt_plugin_provideapolloclient_65d48fd5(app.context, inject)
  }

  if (typeof nuxt_plugin_providesubscriptionunread_60e507aa === 'function') {
    await nuxt_plugin_providesubscriptionunread_60e507aa(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_b5aab5ac === 'function') {
    await nuxt_plugin_meta_b5aab5ac(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
